import React, { Component } from "react";
import './avilableCard.css';
import BgAv from '../../assets/imags/FreeLancerBG.jpg';
import { AllData } from "../../Screens/Home";
import { ChangedData } from "../../assets/ChangedData/ChangedData";

class AvilableCard extends Component{
    
    constructor(){
        super();

        this.state = {
            AVdata: ""
        }

        this.fetchAllData = this.fetchAllData.bind(this);
    }

    componentDidMount(){
        this.fetchAllData();
    }

    async fetchAllData(){
        const allFiles = ["AvilCard"];
        const stateKey = ["AVdata"];

        await fetch(`${process.env.PUBLIC_URL}/mydata/`+ allFiles[0] + ".json").then((r) => r.json()).then((data) =>{
            AllData[allFiles[0]] = data;
            this.state[stateKey[0]] = data;
        }).finally( ()=>{
            if (localStorage.getItem("isLogged") == "true") {
            }
        });
    }

    openDropFContainer(){
        const DropFileContainer = document.getElementById("DropFileContainer");
        DropFileContainer.classList.remove("DropFileContainerZu");

        const DropFileBG = document.getElementById("DropFileBG");
        const BodyVisableZu = document.getElementById("BodyVisableZu");

        setTimeout(() => {
            DropFileBG.classList.remove("DropFileBGZu");
        }, 10);

        setTimeout(() => {
            BodyVisableZu.classList.remove("BodyVisableZu");
        }, 300);
    }

    hoverEditOn(event){
        if (localStorage.getItem("isLogged") == "true") {
            event.target.classList.add("editCursurOnHover");
        }
    }
    hoverEditOut(event){
        let TargetElement = event.target;
        let inn = TargetElement.classList[0];
        let toRemoveElement = document.querySelector("."+inn+" .EditLogoContainer");
        if (toRemoveElement){
            TargetElement.removeChild(toRemoveElement);
        }
    }

    toTextEditFunction(event){
        if (localStorage.getItem("isLogged") == "true") {
            let toTextEdit = event.target;
            let Oldtext = toTextEdit.innerText;
            let Classes = toTextEdit.classList;
            let width = toTextEdit.getBoundingClientRect().width;
            let height = toTextEdit.getBoundingClientRect().height;
            let id = toTextEdit.linke;
    
            toTextEdit.innerHTML = "";
            let textArea = document.createElement("textarea");
            toTextEdit.appendChild(textArea);
            textArea.classList.add("TextEditArea");
    
            for (let i = 0; i < Classes.length; i++) {
                textArea.classList.add(Classes[i]);
            }
    
            textArea.focus();
            textArea.value = Oldtext;
    
            textArea.style.width = width + 20 + "px";
            textArea.style.height = height + 10 + "px";
    

            toTextEdit.addEventListener("focusout" , ()=> {
                
                if ( textArea.value.length > 0) {
                    let NewValueTextarea = textArea.value
                    toTextEdit.innerHTML = NewValueTextarea;
                    // file name
                    let APIfileName = "AvilCard";
                    // atribut name
                    let atributname = event.target.id;
                    // get text after chanched
                    let textafter = event.target.innerHTML;

                    AllData[APIfileName][atributname] = textafter;

                    if (Oldtext != textafter) {
                        let SaveChangContainer = document.getElementById("SaveChangContainer");
                        SaveChangContainer.style.visibility = "visible";

                        if ( !ChangedData[APIfileName]) {
                            ChangedData[APIfileName] = AllData[APIfileName];
                        }
                    }
                }else{
                    // return old Text
                    toTextEdit.innerHTML = Oldtext;
                }
            });
            
            toTextEdit.addEventListener("keydown" , ()=> {
                textArea.style.width = "max-content";
                textArea.style.height = "max-content";
            });
        }
    }


















    render(){
        return(
            <div>
                <div class="FreeLancAvDiv d-flex align-items-center justify-content-center" onMouseOver={this.hoverEditOn} onMouseLeave={this.hoverEditOut}>
                    <div class="FrLancBGimageContainer" >
                        <img class="FrLancBGimage" src={BgAv} alt="" />
                    </div>
                    <div class=" d-flex flex-column align-items-center">
                        <p class="FlpLable" onClick={this.toTextEditFunction} onMouseOver={this.hoverEditOn} onMouseLeave={this.hoverEditOut} id="MainTitle"> { this.state.AVdata.MainTitle }  <span class="Available"> </span> </p>
                        <p class="FlpSText" onClick={this.toTextEditFunction} onMouseOver={this.hoverEditOn} onMouseLeave={this.hoverEditOut} id="UnderTitle"> { this.state.AVdata.UnderTitle } </p>
                        <a href="/#Contact" class="hierMeButtonContainer d-flex align-items-center justify-content-center">
                            HIER ME
                        </a>
                    </div>

                </div>
            </div>
        );
    }
}


export default AvilableCard;